const typographyFormServiceQuesList = {
  itensVerifLabel: 'CHECKLIST ELEMENTOS DE VERIFICACIÓN'
};

export default typographyFormServiceQuesList;
